module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BM-096ff37752b43cd20e511444f837562b.png";